import React, { useCallback, useState } from "react";
import { PrintModal } from "../PersonalTab/ContactDetails/PrintModal";
import { OrganizationTabPaneProps } from "../../../../../Types/ContactType";
import { H5, H6, Image, LI, P, UL } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Utils";
import { Href, Print } from "../../../../../Constants/Constants";

export const OrganizationTabPane:React.FC<OrganizationTabPaneProps> = ({ user }) => {
  const [printModal, setPrintModal] = useState(false);
  const togglePrintModal = () => setPrintModal(!printModal);
  const toggleCallback = useCallback((toggle: boolean) => {
    setPrintModal(toggle);
  }, []);
  return (
    <>
      <div className="profile-mail">
        <div className="d-flex">
          <Image className="img-100 img-fluid m-r-20 rounded-circle update_img_5" src={dynamicImage(`${user.avatar}`)} alt="" />
          <div className="flex-grow-1 mt-0">
            <H5>
              <span className="first_name_5">{user.name}</span>
            </H5>
            <P className="email_add_5">{user.email}</P>
            <UL className="simple-list flex-row">
              <LI>
                <a href={Href} onClick={() => togglePrintModal()}>
                  {Print}
                </a>
              </LI>
            </UL>
          </div>
        </div>
        <div className="email-general">
          <H6>{"General"}</H6>
          <P>
            {"Email Address"}: <span className="font-primary email_add_5">{user.email}</span>
          </P>
          <div className="gender">
            <H6>{"Personal"}</H6>
            <P>
              {"Gender"}: <span>{user.gender}</span>
            </P>
          </div>
        </div>
      </div>
      {user && <PrintModal toggleCallback={toggleCallback} printModal={printModal} selectedUser={user} />}
    </>
  );
};
